<template>
    <el-dialog
        class="modal-body-padding-top-10 modal-body-padding-bottom-0"
        top="5vh"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="title"
        width="1200px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap ml20">
            <el-form ref="form" :model="formItem" :rules="isAddAd?addRules:rules" label-width="110px" inline>
                <el-form-item label="所属广告系列组:" prop="org_id" class="mb6">
                    <el-select v-model="formItem.org_id" ref="select_org_id" filterable reserve-keyword @change="changeSelect('org_id',$event)" :disabled="actionType=='adGroupAddKeyword'" :loading="remoteOrgLoading" placeholder="输入广告系列组ID或名称关键字搜索" class="width245" popper-class="select-option-long-text-wrap">
                        <el-option
                            v-for="item in orgList"
                            :key="item.value"
                            :label="item.label+'【'+item.value+'】'"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属广告系列:" prop="campaign_id" class="mb6">
                    <el-tooltip class="item" effect="dark" content="请先选择所属广告系列组" :disabled="!!formItem.org_id" placement="top">
                        <el-select v-model="formItem.campaign_id" ref="select_campaign_id" filterable reserve-keyword @change="changeSelect('campaign_id',$event)" :disabled="!formItem.org_id||actionType=='adGroupAddKeyword'" :loading="remoteCampaignLoading" placeholder="输入广告系列ID或名称关键字搜索" class="width245" popper-class="select-option-long-text-wrap">
                            <el-option
                                v-for="item in campaignList"
                                :key="item.value"
                                :label="item.label+'【'+item.value+'】'"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="所属广告组:" prop="adgroup_id" class="mb6">
                    <el-tooltip class="item" effect="dark" content="请先选择所属广告系列" :disabled="!!formItem.campaign_id" placement="top">
                        <el-select v-model="formItem.adgroup_id" ref="select_adgroup_id" filterable reserve-keyword @change="changeSelect('adgroup_id',$event)" :disabled="!formItem.org_id||!formItem.campaign_id||actionType=='adGroupAddKeyword'" :loading="remoteAdGroupLoading"  placeholder="输入广告组ID或名称关键字搜索" class="width245" popper-class="select-option-long-text-wrap">
                            <el-option
                                v-for="item in adGroupList"
                                :key="item.value"
                                :label="item.label+'【'+item.value+'】'"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-tooltip>
                </el-form-item>
            </el-form>

            <div class="tool-bar">
                <div class="batch-tool"  v-if="checkedList.length>0">
                    <span class="font12px">已选中{{checkedList.length}}条</span>
                    <el-divider direction="vertical"></el-divider>
                    <el-link type="primary" :underline="false" @click="batchChangeMatchType('精准匹配')">改为精准匹配</el-link>
                    <el-divider direction="vertical"></el-divider>
                    <el-link type="primary" :underline="false" @click="batchChangeMatchType('广泛匹配')">改为广泛匹配</el-link>
                    <el-divider direction="vertical"></el-divider>
                    <el-popover
                        v-model="bidPopover"
                        ref="myPopover"
                        placement="bottom"
                        width="300"
                        trigger="click">
                        <el-link type="primary" slot="reference" :underline="false">修改最高每次点击费用出价</el-link>
                        <div class="custom_input">
                            <el-input
                                size="mini"
                                placeholder="请输入"
                                class="custom_input_el"
                                :value="bid_amount"
                                @input="(value)=>handleInput(value, null)"
                            >
                                <template slot="append" >{{currency}}</template>
                            </el-input>
                            <div class="custom_input_btn">
                                <button class="custom_input_success" @click="handleOK"><i class="el-icon-check"></i></button>
                                <button class="custom_input_close" @click="handleX"><i class="el-icon-close"></i></button>
                            </div>
                        </div>
                    </el-popover>
                    <el-divider direction="vertical"></el-divider>
                    <el-popover
                        placement="bottom"
                        width="160">
                        <p>确定要删除吗？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="cancelBatchRemove">取消</el-button>
                            <el-button type="primary" size="mini" @click="batchRemove">确定</el-button>
                        </div>
                        <el-link slot="reference" type="danger" :underline="false">删除</el-link>
                    </el-popover>
                    <span class="close-btn" @click="hideBatchTool">x</span>

                </div>
                <div class="add-tool" v-else>
                    <el-input
                        resize="none"
                        type="textarea"
                        :rows="1"
                        :autosize="{ minRows: 1, maxRows: 2 }"
                        v-model.trim="add_input"
                        :disabled="addBtnLoading||(!isAddAd&&(!formItem.org_id||!formItem.campaign_id||!formItem.adgroup_id))"
                        @keyup.enter.native.prevent.stop="checkAddKeywords"
                        @input="formatInputVal"
                        size="mini"
                        class="add-input"
                        clearable
                        :placeholder="!formItem.adgroup_id?'请选择广告组后添加关键词':'添加关键词，多个请用英文逗号分割（一个组下最多5000个）。输入完成后可点击右侧添加按钮添加，也可点击键盘回车键添加'">
                    </el-input>
                    <el-button type="primary" size="mini" class="ml20" :disabled="add_input.length<=0" :loading="addBtnLoading" @click="checkAddKeywords" plain>添加</el-button>
                    <div class="text-color-error font12px mt4" v-if="addErrText&&addErrText.length>0&&addErrText!='[]'">{{addErrText}}</div>
                </div>
            </div>
            <div class="data-list">
                <el-table
                    border
                    :header-cell-style="{color:'#333'}"
                    :data="dataList"
                    max-height="350"
                    style="width: 100%;"
                    ref="multipleTable"
                >
                    <el-table-column
                        type="select"
                        width="50"
                        align="center"
                        fixed="left"
                    >
                        <template slot="header" slot-scope="scope">
                            <el-checkbox :indeterminate="indeterminate" :disabled="allList.length<=0" v-model="isCheckAll" @change="handleCheckAllChange"></el-checkbox>
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checked" @change="handleRowSelectChange"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="key_word_text"
                        label="关键词"
                        min-width="150">
                        <template slot="header" slot-scope="scope">
                            <i class="text-color-error"> * </i>关键词
                            <el-tooltip class="item" effect="dark" content="当匹配类型为精准匹配时，会使用括号括住关键词（即 [关键词]）" placement="top">
                                <i class="el-icon-question pointer"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <span v-if="scope.row.match_type=='精准匹配'">[{{scope.row.key_word_text}}]</span>
                            <span v-else>{{scope.row.key_word_text}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="bid_amount"
                        label="最高每次点击费用出价"
                        min-width="150">
                        <template slot="header" slot-scope="scope">
                            <span class="label-required"><i class="text-color-error"> * </i>最高每次点击费用出价</span>
                        </template>
                        <template slot-scope="scope">
                            <div class="custom_input" ref="myParagraphkey">
                                <el-input
                                    resize="none"
                                    size="mini"
                                    placeholder="请输入"
                                    class="custom_input_el"
                                    v-model="scope.row.bid_amount"
                                    @input="(value)=>handleInput(value,scope.row)"
                                    ref="myParagraphread"
                                >
                                    <template slot="append">{{currency}}</template>
                                </el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="match_type"
                        label="匹配类型"
                        align="center"
                        width="200">
                        <template slot="header" slot-scope="scope">
                            <span class="label-required"><i class="text-color-error"> * </i>匹配类型</span>
                        </template>
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.match_type" size="mini">
                                <el-option label="广泛匹配" value="广泛匹配">广泛匹配</el-option>
                                <el-option label="精准匹配" value="精准匹配">精准匹配</el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="action"
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="removeRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>

                    <div slot="empty">
                        <p class="text-color-gray" style="min-height: 200px;margin-top:100px;">关键词默认使用精准匹配和广告组的默认最高每次点击费用出价。</p>
                    </div>
                </el-table>
                <div :style="{textAlign: 'right', paddingTop: '10px'}">
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size="rowNum"
                        :current-page="pn"
                        @current-change="handleCurrentChange"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn ml20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" :disabled="allList.length<=0" class="action-btn ml20">提交</el-button>
        </div>

        <el-dialog
            :title="null"
            :visible.sync="notifyVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            append-to-body
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">正在创建，请稍后…</h5>
                <p class="tac text-color-error pt10 pb20">请勿刷新页面，刷新页面会导致无法及时收到最新结果</p>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index';
    import { get_keyword_modal_err_html } from "../../components/getFlagHtml.js";

    export default {
        name: "KeywordModal",
        props:{
            title:{
                type:String,
                default:'添加关键词',
            },
            actionRows:Array,
            actionType:{
                validator: function (value) {
                    // 仅接受以下值
                    let pageList = [
                        '',
                        'adGroupAddKeyword',    // 创建新广告组
                        'keywordAddKeyword',     // 关键词列表-添加关键词
                        'keywordCopyKeyword',     // 关键词列表-复制关键词
                        'searchTermAddAsKeyword',     // 搜索词列表-添加为关键词

                        'campaignAddNegativeKeyword',   // 创建新广告系列
                        'adGroupAddNegativeKeyword',    // 创建新广告组
                        'keywordAddAsNegativeKeyword',     // 关键词列表-添加为否定关键词
                        'searchTermAddAsNegativeKeyword',     // 搜索词列表-添加为否定关键词
                        'negativeKeywordAddNegativeKeyword',     // 否定关键词列表-添加否定关键词
                        'negativeKeywordCopyNegativeKeyword',     // 否定关键词列表-复制否定关键词
                    ];
                    return pageList.includes(value);
                },
            },
            currencyText:String,
            formData:{
                type:Object,
                default: ()=>{
                    return {};
                },
            },
        },
        inject:['priceDecimalConfig'],
        data(){
            return {
                dialogVisible:false,
                submitLoading:false,
                add_input:'',
                formItem:{
                    org_id:'',
                    campaign_id:'',
                    adgroup_id:'',
                },
                rules:{
                    org_id:[
                        { required: true, message: '请选择所属广告系列组', trigger: 'change' }
                    ],
                    campaign_id:[
                        { required: true, message: '请选择所属广告系列', trigger: 'change' }
                    ],
                    adgroup_id:[
                        { required: true, message: '请选择所属广告组', trigger: 'change' }
                    ],
                },
                addRules:{
                    org_id:[
                        { required: true, message: '请选择所属广告系列组', trigger: 'change' }
                    ],
                    campaign_id:[
                        { required: true, message: '请选择所属广告系列', trigger: 'change' }
                    ],
                },
                orgList:[],
                campaignList:[],
                adGroupList:[],

                remoteOrgLoading:false,
                remoteCampaignLoading:false,
                remoteAdGroupLoading:false,
                addBtnLoading:false,
                oldSelectVal:{
                    org_id:'',
                    campaign_id:'',
                    adgroup_id:'',
                },
                cacha_money: '',  //缓存每日预算
                notifyTip:null,
                notifyVisible:false,
                bid_amount:'',
                bidPopover:false,
                currency:'',
                default_bid_amount:'',
                total: 0,
                pn: 1,
                allList:[],
                rowNum:50,
                isCheckAll:false,   // 批量是否全选
                addErrText:'',

            }
        },
        computed:{
            ...mapGetters(['cur_tab_page']),
            dataList(){
                let start = this.rowNum * (this.pn - 1)
                let end = this.rowNum * (this.pn - 1) + this.rowNum
                return this.allList.slice(start,end)
            },
            isAddAd(){
                return this.actionType=='adGroupAddKeyword';
            },
            checkedList(){
                return this.allList.filter(item=>item.checked);
            },
            indeterminate(){
                let checkedList = this.checkedList;
                return this.allList.length>0&&checkedList.length>0&&checkedList.length<this.allList.length;
            },
            decimalConfig(){
                return this.priceDecimalConfig();
            },
        },
        methods:{
            handleClose(val){
                console.log('handleClose',val);
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                this.formItem.org_id = '';
                this.formItem.campaign_id = '';
                this.formItem.adgroup_id = '';
                this.add_input = '';
                this.submitLoading = false;
                this.$refs.form.resetFields();
                this.orgList = [];
                this.campaignList = [];
                this.adGroupList = [];
                this.allList = [];
                this.addErrText = '';
                this.isCheckAll = false;
                this.currency = '';
            },

            handleSubmit(){
                let noMatchTypeList = this.allList.filter(item=>!item.match_type).map(item=>item.key_word_text);
                let noBidAmountList = this.allList.filter(item=>!item.bid_amount).map(item=>item.key_word_text);
                if(noMatchTypeList.length>0||noBidAmountList.length>0){
                    let matchTypeText = noMatchTypeList.length>0?`<p class="font12px">以下关键词未设置匹配类型：</p><p class="pl20 font12px">${noMatchTypeList.join('，')}</p>`:'';
                    let bidAmountText = noBidAmountList.length>0?`<p class="mt20 font12px">以下关键词未设置最高每次点击费用出价：</p><p class="pl20 font12px">${noBidAmountList.join('，')}</p>`:'';
                    let htmlStr = `<div style="max-height: 300px;overflow-y: auto;padding-right: 10px;">${matchTypeText}${bidAmountText}</div>`;
                    this.$alert(htmlStr, '提交失败', {
                        dangerouslyUseHTMLString:true,
                        type:"error",
                        confirmButtonText: '确定',
                    });
                    return false;
                }

                let repeatArr = [];
                let tempObj = {};
                this.allList.forEach(item=>{
                    if(!tempObj[item.key_word_text]){
                        tempObj[item.key_word_text] = true;
                    }else{
                        repeatArr.push(item.key_word_text);
                    }
                });
                tempObj = null;
                if(repeatArr.length>0){
                    this.$notify.error({
                        title: '提交失败',
                        message: '<div style="max-height: 300px;overflow-y: auto;padding-right: 10px;">列表中存在重复的关键词：'+repeatArr.join('，')+'</div>',
                        dangerouslyUseHTMLString: true,
                        duration: 0,
                    });
                    return false;
                }

                if(this.isAddAd){
                    this.$emit('save',this.allList);
                    this.handleClose();
                    return false;
                }
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log('handleSubmit');
                        if(!this.actionType) return ;
                        this.submitLoading = true;
                        this.notifyVisible = true;
                        let currency_time = new Date().valueOf()
                        let current_name = `keywordModal_${currency_time}`

                        let rowData = this.allList.map(item=>{
                            return {
                                text:item.key_word_text,
                                match_type:item.match_type=='精准匹配'?'EXACT':(item.match_type=='广泛匹配'?'BROAD':''),
                                bid_amount:item.bid_amount,
                            }
                        });

                        API[this.actionType]({
                            current_name:current_name,
                            org_id:this.formItem.org_id,
                            campaign_id:this.formItem.campaign_id,
                            adgroup_id:this.formItem.adgroup_id,
                            data:JSON.stringify(rowData),
                        },{
                            timeout: 120*1000,
                        }).then(res=>{
                            this.notifyVisible = false;
                            this.submitLoading = false;
                            console.log('createKeywords',res);
                            let resData = res.data||{};
                            let msgText = resData.msg||'';
                            this.$notify.success({
                                title: res.info||'操作成功',
                                dangerouslyUseHTMLString: true,
                                message: '<p>'+msgText+'</p>',
                            });
                            this.dialogVisible = false;
                            this.$emit('update');
                            this.resetForm();

                        },err=>{
                            this.notifyVisible = false;
                            this.submitLoading = false;
                            console.log('createKeywords err',err);
                            if(err.code =='403'){
                                this.$confirm(err.info, '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                                return
                            }

                            let errData = err.data||{};
                            let errMsg = errData.msg||'';
                            let errInfo = err.info||'超时未响应：操作结果未返回，请人工登录媒体平台确认操作结果！也可尝试重试';
                            let repeat_keyword = errData.repeat_keyword||[];
                            if(repeat_keyword.length>0){
                                console.log('repeat_keyword',repeat_keyword);
                                let htmlStr = `<p class="text-color-error">${errMsg}，是否删除？</p><p class="break-word">${repeat_keyword.join(',')}</p>`;
                                this.$confirm(htmlStr, errInfo, {
                                    closeOnPressEscape:false,
                                    dangerouslyUseHTMLString: true,
                                    confirmButtonText: '删除',
                                    cancelButtonText: '取消',
                                    confirmButtonClass: 'danger-btn1',
                                    type: 'warning',
                                }).then(() => {
                                    console.log(repeat_keyword,'删除');
                                    repeat_keyword.forEach(item=>{
                                        let actionRow = this.allList.find(inner=>inner.key_word_text==item);
                                        this.removeRow(actionRow);
                                    });
                                    if(this.allList.length>0){
                                        this.handleSubmit();
                                    }else{
                                        this.$notify.error({
                                            title: '提示',
                                            message: '关键词列表为空，请添加关键词',
                                        });
                                    }
                                }).catch(() => {
                                    console.log(repeat_keyword,'取消')
                                });
                            }else{
                                let errList = (errData.error||{}).errMsg||[];

                                let htmlStr=get_keyword_modal_err_html(errInfo, errMsg, errList,current_name);
                                this.notifyTip = this.$notify({
                                    showClose: false,
                                    duration: 0,
                                    dangerouslyUseHTMLString: true,
                                    message: htmlStr,
                                    customClass:'width400',
                                });
                                this.$store.commit('apple/ADD_NOTIFY',{
                                    id: `${current_name}_close`,
                                    value:this.notifyTip,
                                });
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{

                    if(this.currencyText){
                        this.currency = this.currencyText;
                    }

                    this.getOrgSelectorList();

                    if(['adGroupAddKeyword','keywordCopyKeyword','searchTermAddAsKeyword'].includes(this.actionType)){
                        let actionRows = this.actionRows||[];
                        let formData = this.formData||{};

                        if(formData.org_id){
                            this.formItem.org_id = formData.org_id;
                            this.oldSelectVal.org_id = formData.org_id;
                            this.orgList = [{
                                value:formData.org_id,
                                label:formData.org_name,
                            }];
                            this.getCampaignSelectorList();
                        }
                        if(formData.campaign_id){
                            this.formItem.campaign_id = formData.campaign_id;
                            this.oldSelectVal.campaign_id = formData.campaign_id;
                            this.campaignList = [{
                                value:formData.campaign_id,
                                label:formData.campaign_name,
                            }];
                            this.getAdGroupSelectorList();
                        }
                        if(formData.adgroup_id&&this.actionType!='keywordCopyKeyword'){
                            this.formItem.adgroup_id = formData.adgroup_id;
                            this.oldSelectVal.adgroup_id = formData.adgroup_id;
                            this.adGroupList = [{
                                value:formData.adgroup_id,
                                label:formData.adgroup_name,
                            }];
                            this.getCreateAdGroupInfo().then(()=>{
                                this.allList.forEach(item=>{
                                    if(!item.bid_amount){
                                        item.bid_amount = this.default_bid_amount;
                                    }
                                })
                            });
                        }

                        /* 处理重复关键词 */
                        let dataList = [];
                        actionRows.forEach(item=>{
                            if(!dataList.find(inner=>inner.key_word_text==item.key_word_text&&inner.match_type==item.match_type)){
                                dataList.push({
                                    key_word_text:item.key_word_text,
                                    match_type:item.match_type,
                                    bid_amount:item.bid_amount,
                                    checked:false,
                                });
                            }
                        });
                        this.total = dataList.length ? dataList.length : 0;
                        this.allList = dataList;
                    }
                });

            },
            getOrgSelectorList(){
                this.remoteOrgLoading = true;
                API.getOrgSelectorList({
                    search:'',
                    source_page:this.cur_tab_page,
                }).then(res=>{
                    let resData = res.data||[];
                    this.orgList = resData.map(item=>{
                        return {
                            value:item.org_id,
                            label:item.org_name,
                        }
                    });
                    this.remoteOrgLoading = false;
                },err=>{
                    console.log('getOrgSelectorList err',err);
                    this.orgList = [];
                    this.remoteOrgLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            getCampaignSelectorList(){
                this.remoteCampaignLoading = true;
                API.getCampaignSelectorList({
                    org_id:this.formItem.org_id,
                    search:'',
                    source_page:this.cur_tab_page,
                    supply_source:2,
                }).then(res=>{
                    let resData = res.data||[];
                    this.campaignList = resData.map(item=>{
                        return {
                            value:item.campaign_id,
                            label:item.campaign_name,
                        }
                    });
                    this.remoteCampaignLoading = false;
                },err=>{
                    console.log('getCampaignSelectorList err',err);
                    this.campaignList = [];
                    this.remoteCampaignLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            getAdGroupSelectorList(){
                this.remoteAdGroupLoading = true;
                API.getAdGroupSelectorList({
                    org_id:this.formItem.org_id,
                    campaign_id:this.formItem.campaign_id,
                    search:'',
                    source_page:this.cur_tab_page,
                }).then(res=>{
                    let resData = res.data||[];
                    this.adGroupList = resData.map(item=>{
                        return {
                            value:item.adgroup_id,
                            label:item.adgroup_name,
                        }
                    });
                    this.remoteAdGroupLoading = false;
                },err=>{
                    console.log('getAdGroupSelectorList err',err);
                    this.adGroupList = [];
                    this.remoteAdGroupLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            checkAddKeywords(){
                this.add_input = this.add_input.replace(/,$/,'');
                let inputVal = this.add_input;

                this.addBtnLoading = true;
                this.addErrText = '';
                let currency_time = new Date().valueOf()
                let current_name = `checkKeywordModal_${currency_time}`
                API.checkAddKeywords({
                    current_name:current_name,
                    keyword_type:'targeting',        // 关键词,campaign_negative：广告系列否定关键词,adgroup_negative：广告组否定关键词
                    texts:inputVal,
                    org_id:this.formItem.org_id,
                    campaign_id:this.formItem.campaign_id,
                    adgroup_id:this.formItem.adgroup_id,
                },{
                    timeout: 120*1000,
                }).then(res=>{
                    this.addBtnLoading = false;
                    let resData =res.data||{};
                    let res_keyword = resData.res_keyword||[];

                    if(res_keyword.length+this.allList.length>5000){
                        let diff = res_keyword.length+this.allList.length - 5000;
                        this.addErrText = '广告组最高拥有5000个关键词，超出'+diff+'个。无法继续添加';
                    }else{
                        res_keyword.forEach(item=>{
                            if(!this.allList.find(inner=>inner.key_word_text==item)&&!!item){
                                this.allList.unshift({
                                    key_word_text:item,
                                    match_type:'精准匹配',
                                    bid_amount:this.default_bid_amount||'',
                                    checked:false,
                                })
                            }
                        });
                        this.add_input = '';
                        this.pn = 1;
                        this.total = this.allList.length;
                    }
                },err=>{
                    console.log('checkAddKeywords err',err);
                    this.addBtnLoading = false;

                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }

                    let errData = err.data||{};
                    let errInfo = err.info||'请求失败';
                    let errMsg = errData.msg||'';
                    let repeat_keyword = errData.repeat_keyword||[];
                    if(repeat_keyword.length>0){
                        this.addErrText = errMsg+':'+repeat_keyword.join('，');
                    }else{
                        this.addErrText = errMsg||errInfo;
                    }



                    // let res_keyword = errData.res_keyword||[];
                    // res_keyword.forEach(item=>{
                    //     if(!this.allList.find(inner=>inner.key_word_text==item)&&!!item){
                    //         this.allList.unshift({
                    //             key_word_text:item,
                    //             match_type:'精准匹配',
                    //             bid_amount:this.default_bid_amount||'',
                    //             checked:false,
                    //         })
                    //     }
                    // });
                    //
                    // if(repeat_keyword.length>0){
                    //     console.log('repeat_keyword',repeat_keyword);
                    //     let htmlStr = `<p class="text-color-error">${errMsg}，是否删除？</p><p>${repeat_keyword.join(',')}</p>`;
                    //     this.$confirm(htmlStr, errInfo, {
                    //         closeOnPressEscape:false,
                    //         dangerouslyUseHTMLString: true,
                    //         confirmButtonText: '删除',
                    //         cancelButtonText: '取消',
                    //         confirmButtonClass: 'danger-btn1',
                    //         type: 'warning',
                    //     }).then(() => {
                    //         this.add_input = errData.res_text;
                    //     }).catch(() => {
                    //
                    //     });
                    // }else{
                    //     let errList = (errData.error||{}).errMsg||[];
                    //
                    //     let htmlStr=get_keyword_modal_err_html(errInfo, errMsg, errList,current_name);
                    //     this.notifyTip = this.$notify({
                    //         showClose: false,
                    //         duration: 0,
                    //         dangerouslyUseHTMLString: true,
                    //         message: htmlStr,
                    //         customClass:'width400',
                    //     });
                    //     this.$store.commit('apple/ADD_NOTIFY',{
                    //         id: `${current_name}_close`,
                    //         value:this.notifyTip,
                    //     });
                    //     this.add_input = errData.res_text;
                    //
                    //
                    // }
                })
            },
            removeRow(row){
                let rowIndex = this.allList.findIndex(item=>item.key_word_text==row.key_word_text&&item.match_type==row.match_type);
                this.allList.splice(rowIndex,1);
                this.total =  this.allList.length;
                this.handleRowSelectChange();
            },
            cancelBatchRemove(){
                /* 隐藏弹窗，随便找个元素click一下就好 */
                let $batchTool = document.querySelector('.batch-tool');
                if($batchTool){
                    $batchTool.click();
                }
            },
            batchChangeMatchType(val){
                this.checkedList.forEach(item=>{
                    item.match_type = val;
                });
            },
            batchRemove(){
                this.checkedList.forEach(item=>{
                    this.removeRow(item);
                });
            },
            changeSelect(type,val){
                console.log('changeOrgSelect',val);
                if(type=='org_id'&&val!=''){
                    this.formItem.campaign_id = '';
                    this.formItem.adgroup_id = '';
                    this.campaignList = [];
                    this.adGroupList = [];
                    this.getOrgConfig();
                    this.getCampaignSelectorList();
                }
                if(type=='campaign_id'&&val!=''){
                    this.formItem.adgroup_id = '';
                    this.adGroupList = [];
                    this.getAdGroupSelectorList();
                }
                if(type=='adgroup_id'&&val!=''){
                    this.getCreateAdGroupInfo();
                }
                // if(!this.oldSelectVal[type]){
                //     this.oldSelectVal[type] = this.formItem[type];
                // }else if(val!=this.oldSelectVal[type]){
                //     let typeMap = {
                //         org_id:'广告系列组',
                //         campaign_id:'广告系列',
                //         adgroup_id:'广告组',
                //     };
                //     this.$confirm('修改'+typeMap[type]+'，已填写的内容将会被清空', '提示', {
                //         closeOnPressEscape:false,
                //         dangerouslyUseHTMLString: true,
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning',
                //     }).then(() => {
                //         console.log('resetData',type);
                //         this.resetData(type);
                //         /*手动隐藏下拉筛选框*/
                //         this.$refs['select_'+type].blur();
                //         this.oldSelectVal[type] = this.formItem[type];
                //     }).catch(() => {
                //         this.formItem[type] = this.oldSelectVal[type];
                //         /*手动隐藏下拉筛选框*/
                //         this.$refs['select_'+type].blur();
                //     });
                // }
            },
            getCreateAdGroupInfo(){
                if(!this.formItem.org_id||!this.formItem.adgroup_id) return;
                return API.get_create_adgroup_info({
                    org_id:this.formItem.org_id,
                    adgroup_id:this.formItem.adgroup_id,
                }).then(res=>{
                    let resData = res.data||{};
                    this.default_bid_amount = resData.default_bid_amount;
                    this.currency = this.currency?this.currency:resData.default_bid_amount_currency;

                },err=>{
                    console.log('get_create_adgroup_info err',err);
                    this.default_bid_amount = '';
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            getOrgConfig(){
                API.getOrgConfig({
                    org_id:this.formItem.org_id,
                }).then(res=>{
                    let resData = res.data||{};
                    this.currency = resData.currency||'元';
                })
            },
            resetData(type){
                console.log('resetData',111,type);
                if(type=='org_id'){
                    this.formItem.campaign_id = '';
                    this.formItem.adgroup_id = '';
                }else if(type=='campaign_id'){
                    this.formItem.adgroup_id = '';
                }
                this.add_input = '';
                this.allList = [];
                this.isCheckAll = false;
                this.addErrText = '';
                this.$nextTick(()=>{
                    this.$refs.form.clearValidate();
                });
            },
            // 只可以输入数字
            handleInput(val, rows, limit = 2) {
                if(this.currency=='美元'){
                    let USDConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='USD')||{};
                    limit = USDConfig.decimal_places||2;
                }

                let rval = val.replace(/[^1-9\d.]/g, ''); //保留数字

                rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                rval = rval.replace(/[^1-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                if(rows){
                    rows.bid_amount = rval
                }else{
                    this.bid_amount = rval;
                }
            },
            handleOK(){
                console.log('handleOK');
                this.bidPopover = false;
                this.checkedList.forEach(item=>{
                    item.bid_amount = this.bid_amount;
                });
                this.bid_amount = '';
            },
            handleX(){
                console.log('handleX');
                this.bidPopover = false;
                this.bid_amount = '';
            },
            formatInputVal(val){
                this.add_input = val.replaceAll('\n',',').replaceAll('\r\n',',');
            },
            handleCurrentChange(val) {
                this.pn = val
            },
            hideBatchTool(){
                console.log('hideBatchTool');
                this.allList.forEach(item=>{
                    item.checked = false;
                });
                this.isCheckAll = false;
            },
            handleCheckAllChange(val){
                console.log('handleCheckAllChange',val);
                this.allList.forEach(item=>{
                    item.checked = val;
                })
            },
            handleRowSelectChange(){
                this.isCheckAll = this.allList.length>0&&this.allList.every(item=>item.checked);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .tool-bar{
        min-height: 50px;
        background-color: #f2f2f2;
        /*border: solid silver 1px;*/
        padding: 10px;
        margin: 10px 0;
        .add-input{
            width: calc(100% - 120px);
        }

        .batch-tool{
            width: 650px;
            height: 28px;
            line-height: 26px;
            background-color: #fff;
            border: solid silver 1px;
            padding-left: 10px;
            position: relative;
            .close-btn{
                display: inline-block;
                width:20px;
                text-align: center;
                height: 20px;
                line-height: 20px;
                position: absolute;
                right: 5px;
                top: 3px;
                cursor: pointer;
                &:hover{
                    color: #333;
                }
            }
        }
    }

    .mb6{
        margin-bottom: 6px;
    }
    .width245{
        width: 245px;
    }


    .custom_input{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 3px;
        padding: 3px;
        .el-input-group__append{
            padding: 0 8px;
        }
        &.active{
            box-shadow: 0 1px 8px #bbb6b6;
        }
        .custom_input_el{
            margin-right: 4px;
            flex: auto;
        }
        .custom_input_btn{
            width: 48px;
            flex: 0 0 48px;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        .custom_input_success{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 2px solid #67C23A;
            border-radius: 10px;
            background-color: #67C23A;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #9ed881;
                background-color: #9ed881;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
        .custom_input_close{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            border: 2px solid #F56C6C;
            background-color: #F56C6C;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #fe9999;
                background-color: #fe9999;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
    }

</style>
